export const periods = {
  // DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
  YEAR: 'year'
};

export const VIEW_TYPE_OPTIONS = {
  TOTAL: 'total',
  AI: 'ai',
  DEVELOPER: 'developer'
};

export const VIEW_TYPE_LABELS = {
  TOTAL: 'Baseline Effort (Without AI)',
  AI: 'Effort Saved by AI',
  DEVELOPER: 'Human Effort Required'
};

export const operations = {
  COMMITS: '',
  // NET_INSERTION: 'net_insertions',
  // NET_DELETION: 'net_deletions',
  //BASE_EFFORT: 'base_effort',
  // CODE_EFFORT: 'code_effort',
  GIT_EFFORT: 'git_effort',
  INVESTMENT: 'investment'
};

export const OPERATION_LABEL = {
  COMMITS: 'Commits',
  GIT_EFFORT: 'R.E.V',
  INVESTMENT: 'Value ($)'
};

export const calculations = {
  COUNT: 'count',
  RATIO: 'ratio'
};

export const CALCULATION_METHODS = {
  COUNT: 'Count',
  RATIO: 'Ratio'
};

export const ALLOW_COLUMNS = {
  repos: 'repo_uid',
  authors: 'author_uid',
  projects: 'project_uid',
  branches: 'merged_branch_uids',
  tags: 'tags',
  categories: ['Bug_Fixes'],
  total: 'total'
};

export const CARD_INFO_TEMPLATE = {
  gitEfforts: {
    label: 'Baseline Effort (Without AI)',
    count: '',
    icon: 'CodeIcon',
    info: ''
  },
  commits: {
    label: 'Total Commits',
    count: '',
    url: '/commit-details',
    icon: 'CodeIcon',
    info: '',
    infoLabel: 'Last Date'
  },
  projects: {
    label: 'Total Active Projects',
    count: '',
    url: '/projects',
    icon: 'ArchiveIcon',
    info: ''
  },
  repos: {
    label: 'Total Active Repositories',
    count: '',
    url: '/repos',
    icon: 'CubeIcon',
    info: ''
  },
  authors: {
    label: 'Total Active Developers',
    url: '/developers',
    count: '',
    icon: 'UsersIcon',
    info: ''
  }
};
